<template>
  <div class="column-container">
    <CardTitle :title="$t('pc_community_special')" :path="'/communityColumnPage'"></CardTitle>
    <div class="content" v-if=" boardsData?.records">
      <div class="item" v-for="(item, index) in boardsData?.records.slice(0,6)" :key="index" @click="handleJump(item.id, item.type)">
        <div class="img-wrapper">
          <img class="img" :src=item.coverUrl alt="" />
        </div>
        <div class="text">{{ item.name }}</div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import CardTitle from '@/components/CardTitle.vue'
import { ColumnBoardPage } from '@/api/Models/CommunityHomeData'
import { useRouter } from 'vue-router'

defineProps<{
  boardsData: ColumnBoardPage
}>()
const router = useRouter()
const handleJump = (id:string, type: number) => {
  router.push({ path: '/communityDetail', query: { id, type } })
}

</script>

<style lang="less" scoped>
.column-container {
  width: 100%;
  margin-top: 14px;
  padding: 16px 12px 12px;
  box-sizing: border-box;
  background: #ffffff;
  border-radius: 6px;

  .content {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin-top: 12px;

    .item {
      display: flex;
      align-items: center;
      justify-content: center;
      width: calc((100% - 4px) / 2);
      height: 42px;
      padding: 5px;
      box-sizing: border-box;
      border: 0.5px solid #e1e1e1;
      border-radius: 6px;
      margin-bottom: 4px;

      .img-wrapper {
        width: 32px;
        height: 32px;
        border-radius: 4px;
        overflow: hidden;
        margin-right: 6px;

        .img {
          width: 100%;
          height: 100%;
        }
      }

      .text {
        flex: 1;
        color: #61666d;
        font-size: 13px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
}
</style>
